import { useEffect, useState } from "react";
import CreateStoreCollectionModal from "./CreateStoreCollectionModal";
import { toast } from "sonner";
import { api, getCollectionsBySalesForceId } from "../../../services/axios";

interface StoreCollection {
  id: string;
  admin_graphql_api_id: string;
  handle: string;
  description: string;
  title: string;
  shopify_id: string;
  store: string;
}

export default function StoreCollectionsTable({
  salesforce_id,
}: {
  salesforce_id: string;
}) {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [storeCollections, setStoreCollections] = useState<StoreCollection[]>(
    []
  );

  const loadStoreCollection = async () => {
    if (salesforce_id) {
      let result = (await getCollectionsBySalesForceId(
        String(salesforce_id)
      )) as StoreCollection[];
      console.log("store collections", result);
      setStoreCollections(result);
    }
  };
  useEffect(() => {
    loadStoreCollection();
  }, [modalVisible, salesforce_id]);

  const deleteCollection = async (collection: string) => {
    return api
      .delete(`collections/${collection}`)
      .then(() => {
        toast.success("deleted", { duration: 5000 });
      })
      .catch((e) => toast.error(e.message, { duration: 5000 }));
  };

  const constructStoreURL = (store: StoreCollection) => {
    return `https://admin.shopify.com/store/${store.store}/collections/${store.shopify_id}`;
  };

  return (
    <div className="my-8  w-full border border-b rounded p-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">
            Store Collections
          </h1>
        </div>
        <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
          <button
            onClick={() => setModalVisible(true)}
            type="button"
            className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
          >
            Create New
          </button>
        </div>
      </div>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Shopify ID
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Title
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Description
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Collection Link
                    </th>

                    <th
                      scope="col"
                      className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-6"
                    >
                      <span className="sr-only">View</span>
                    </th>
                    <th
                      scope="col"
                      className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-6"
                    ></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {storeCollections?.map((storeCollections, index) => (
                    <tr key={index}>
                      <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                        {storeCollections.id}
                      </td>
                      <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                        {storeCollections.shopify_id}
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900">
                        {storeCollections.title}
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
                        {storeCollections.description}
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                        {constructStoreURL(storeCollections)}
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                        <button
                          onClick={() => deleteCollection(storeCollections.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <CreateStoreCollectionModal
        salesforce_id={salesforce_id}
        visible={modalVisible}
        setVisible={setModalVisible}
      />
    </div>
  );
}
